export default function ({state, rootState, rootGetters}) {
  if(state.system.type ==='pay'&& state.system.action ==='order'&&rootState.settings.paymentItems.reopenPayToAgreement){
    window.app.$router.push(`/finances/payments/edit/${state.system.saveId}`);
    return
  }
    if (rootGetters.permission(186)) {
        switch (state.system.type) {
            case 'pay':
                if (rootGetters.permission(33) || rootGetters.permission(79) || rootGetters.permission(80) || rootGetters.permission(127)) {
                    if (rootState.route.fullPath.indexOf('payments-details') > 0) {
                        window.app.$router.push('/finances/payments-details');
                    } else {
                        window.app.$router.push('/finances/payments');
                    }
                } else {
                    if (state.form.AgreementCodes && state.form.AgreementCodes[0]) {
                        window.location.href = '/tourclient/admin/orders/info.html?code=' + state.form.AgreementCodes[0];
                    } else {
                        window.app.$router.push('/finances');
                    }
                }
                break;
            case 'regular':
                if (rootGetters.permission(135) || rootGetters.permission(136) || rootGetters.permission(137) || rootGetters.permission(138)) {
                    window.app.$router.push('/finances/regulars');
                } else {
                    if (state.form.AgreementCodes && state.form.AgreementCodes[0]) {
                        window.location.href = '/tourclient/admin/orders/info.html?code=' + state.form.AgreementCodes[0];
                    } else {
                        window.app.$router.push('/finances');
                    }
                }
                break;
            case 'invoice':
                if (rootGetters.permission(139) || rootGetters.permission(140) || rootGetters.permission(141) || rootGetters.permission(142)) {
                    window.app.$router.push('/finances/invoices');
                } else {
                    if (state.form.AgreementCodes && state.form.AgreementCodes[0]) {
                        window.location.href = '/tourclient/admin/orders/info.html?code=' + state.form.AgreementCodes[0];
                    } else {
                        window.app.$router.push('/finances');
                    }
                }
                break;
            default:
                window.app.$router.push('/finances');
        }
    } else {
        if (state.form.AgreementCodes && state.form.AgreementCodes[0]) {
            window.location.href = '/tourclient/admin/orders/info.html?code=' + state.form.AgreementCodes[0];
        } else {
            window.location.href = '/tourclient/admin/';
        }
    }
}